import { Box, InputLabel, Slider } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const RotationSlider = ({ rotation, setRotationSlider, setRotation }) => {
  const { t } = useTranslation();

  return (
    <Box id="rotation" px={1}>
      <InputLabel shrink>{t("/editor.gui.rotation")}</InputLabel>
      <Slider
        min={0}
        max={360}
        step={1}
        value={rotation}
        onChangeCommitted={(e, v) => setRotation(v)}
        onChange={(e, v) => setRotationSlider(v)}
        marks
        valueLabelDisplay="auto"
      />
    </Box>
  );
};

export default RotationSlider; 